///<reference path="../../../../../../../node_modules/@angular/core/src/change_detection/constants.d.ts"/>
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {GameService} from '../game.service';

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardComponent implements OnInit {

  constructor(public game: GameService) { }

  playCell(i, j) {
    if (this.game.board[i][j]) {
      alert('Please choose an empty cell!');
    } else {
      this.game.play(i, j);
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/board/board.component.ts